<template>
  <v-container class="show-overflow">
    <app-loading :loading="loading">
      <div>
        <app-header :buttonAction="action">
          <template v-slot:title>{{ data.title }}</template>
          <template v-slot:subtitle>{{ data.subtitle }}</template>
        </app-header>
        <app-explanation class="mt-5">
          <template v-slot:body>{{ data.description }}</template>
        </app-explanation>
        <app-video-component v-if="data.lesson_file" class="my-10" :src="data.lesson_file" />
      </div>
    </app-loading>
    <app-rich-text ref="editor" :body="JSON.parse(data.rich_text)">
      <template v-slot:title>{{ data.rich_title }}</template>
    </app-rich-text>
    <div v-if="data.question_group">
      <v-row>
        <v-col
          cols="12"
          sm="6"
          v-for="(question, index) in data.question_group.questions"
          :key="'Question' + index"
        >
          <app-pronunciation-card
            :content="question.content"
            :src="question.question_file"
            disableAnswer
          >
            <template #title>
              <span />
            </template>
          </app-pronunciation-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import Header from "@/components/Lessons/Lesson/components/Header.vue";
import Explanation from "@/components/Lessons/Lesson/components/Explanation";
import RichText from "@/components/Lessons/Lesson/components/RichText";
import VideoComponent from "@/components/Lessons/Lesson/components/VideoComponent.vue";
import Loading from "@/components/Loading.vue";
import directionMixin from "@/mixins/directionMixin";
import PronunciationCard from "./PronunciationCard.vue";

import { getVocabulary } from "@/api/api";

export default {
  components: {
    appHeader: Header,
    appExplanation: Explanation,
    appRichText: RichText,
    appVideoComponent: VideoComponent,
    appLoading: Loading,
    appPronunciationCard: PronunciationCard,
  },
  mixins: [directionMixin],
  data() {
    return {
      data: {
        rich_text: '{"type": "doc","content": []}',
      },
      loading: true,
    };
  },
  methods: {
    action() {
      this.$emit("next-step");
      this.updateProgress("vocabulary_step");
    },
  },
  async created() {
    this.loading = true;

    const response = await getVocabulary(this.source.vocabulary_step, this.direction);

    this.data = response.data;
    this.loading = false;
  },
};
</script>
<style scoped>
.show-overflow {
  overflow-x: visible !important;
}
</style>
